import type { FC, MouseEvent, PropsWithChildren } from "react";
import LinkMBC from "./LinkMBC";
import LinkWEB from "./LinkWEB";
import useCustomer from "~/shared/api/useCustomer";
import { trackClick, useTracking } from "@sb1f/tracking";
import { hentTekstFraChildren } from "../ffe-buttons/knappeUtils";
import { transformerTekst } from "~/utils/tracking/utils";
import mbc from "~/shared/functions/mbc";

export function externNavigering(path: string, type?: "pdf" | "web"): boolean {
	return path.startsWith("http") || type === "pdf";
}

function hvisTilSparebank1(to?: string, bankDomain?: string): string {
	if (!to) return "";
	if (bankDomain && to.includes("/nb/bank/")) {
		return to.replace("/nb/bank/", `/nb/${bankDomain}/`);
	}
	return to;
}

export function isPdfLink(path?: string): boolean {
	if (!path) return false;
	return path.toLowerCase().endsWith(".pdf");
}

export function fullUrl(path: string): string {
	if (path.startsWith("/")) {
		return window.location.origin + path;
	}
	return path;
}

export interface LinkProps {
	to: string;
	onClick?(event?: MouseEvent<HTMLAnchorElement>): void;
	className?: string;
	"data-testid"?: string;
	type?: "pdf" | "web";
	navigationBarTitle?: string;
	presentationStyle?: "INTERNAL" | "EXTERNAL" | "SHEET";
	onReturn?(): void;
	closeEntireExternalLayer?: boolean;
	authenticationUpgradeRequired?: boolean;
	knappNavn?: string;
	state?: object;
}

const Link: FC<PropsWithChildren<LinkProps>> = ({ to, onClick, ...props }) => {
	const kunde = useCustomer();
	const tracking = useTracking();
	const isPdf = isPdfLink(to);
	const linkProps = isPdf ? ({ ...props, type: "pdf" } as const) : { ...props };

	const handleClick = (event?: MouseEvent<HTMLAnchorElement>) => {
		const knappeNavn = props.knappNavn ? props.knappNavn : `${props.children ? hentTekstFraChildren(props.children) : to}`;
		trackClick(transformerTekst(knappeNavn), "link", tracking.page);
		onClick?.(event);
	};

	if (mbc.isNative()) {
		return <LinkMBC to={hvisTilSparebank1(to, kunde.bankDomain)} {...linkProps} onClick={handleClick} />;
	}
	return <LinkWEB to={hvisTilSparebank1(to, kunde.bankDomain)} {...linkProps} onClick={handleClick} />;
};

export default Link;
